import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { z } from 'zod';
import { zodI18nMap } from 'zod-i18n-map';
import ar from './locale/ar.json';
import en from './locale/en.json';
import enZod from './locale/en-zod.json';
import arZod from './locale/ar-zod.json';
import dayjs from 'dayjs';
import 'dayjs/locale/ar';
import 'dayjs/locale/en';
import { trackEvent } from './utils/analytics';

const savedLanguage = localStorage.getItem('lang') || 'en';
const isLanguageRestored = !!localStorage.getItem('lang');

i18next.use(initReactI18next).init({
  // debug: import.meta.env.DEV,
  ns: ['translation', 'zod'],
  resources: {
    en: {
      zod: enZod,
      translation: en,
    },
    ar: {
      zod: arZod,
      translation: ar,
    },
  },
  lng: savedLanguage,
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
});

i18next.init(
  {
    lng: savedLanguage,
    react: {
      bindI18n: 'languageChanged',
    },
  },
  () => {
    document.documentElement.lang = i18next.language;
    document.documentElement.dir = i18next.dir(i18next.language);

    // Track persisted language if it was restored from localStorage
    if (isLanguageRestored) {
      trackEvent('persisted_language', 'Localization', {
        session_restore: 'true',
        lang_code: savedLanguage,
      });
    }
  },
);

i18next.on('languageChanged', (lang) => {
  document.documentElement.lang = lang;
  document.documentElement.dir = i18next.dir(lang);
  localStorage.setItem('lang', lang);
  dayjs.locale(lang);
});

z.setErrorMap(zodI18nMap);

export { i18next, z };
